import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import Recorder from "../QuestionPage/recorder";
import { useState, useEffect } from "react";

// Fetching Data from the API]

// End

// Page Html
export default function PersonalIntroductionPage(props) {
  const { onInputChange } = props;
  const [text, setText] = useState("");

  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const handleTextChange = (newText) => {
    if (newText !== text) {
      setText(newText);
      onInputChange(newText);
    }
  };
  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  italic pt-3 font-bold text-gray-900 sm:text-lg ml-1 text-center md:text-start">
          Read the prompt below. In 25 seconds, you must reply in your own word,
          as naturally as clear as possible. You will have 30 seconds to give
          your response
        </h3>

        <Recorder
          text={text}
          setText={handleTextChange}
          {...props}
          duration={20}
          className="relative left-[450px] ml-6 mt-5 mb-5 bg-gray-100 w-[440px] h-56 border-4"
        />
        <ul className="p-6">
          Please introduce yourself. For example you could talk one or more of
          the following
          <li className=" list-disc pl-4">Your interests </li>
          <li className=" list-disc pl-4">Your plans for future study</li>
          <li className=" list-disc pl-4">Why you want to study abroad </li>
          <li className=" list-disc pl-4">Why you need to learn english</li>
          <li className=" list-disc pl-4">Why you choose this test</li>
        </ul>
      </div>
    </div>
  );
}
